import { createClient } from '@supabase/supabase-js';

// Shared identity project (same one IrieLearn and IrieMind use). Only used
// for the password-recovery link flow - normal login goes through this
// app's own backend (see AuthContext / services/api.js).
//
// createClient() throws synchronously if given an empty URL/key, and this
// module is imported eagerly - so a missing env var here would crash the
// ENTIRE app on load (including the login page), not just the forgot/
// reset-password screens that actually need it. Fall back to a placeholder
// so a misconfigured deploy only breaks password recovery (with a clear
// console warning) instead of the whole site.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('[supabaseClient] REACT_APP_SUPABASE_URL/REACT_APP_SUPABASE_ANON_KEY are not set - password recovery will not work until this deploy is configured.');
}

export const supabase = createClient(
  supabaseUrl || 'https://misconfigured.invalid',
  supabaseAnonKey || 'misconfigured'
);
